import {FC} from "react";
import {Bar} from "react-chartjs-2";
import {TeamProgressGraphStatistics} from "../../../../lib/src/api/repositories/learn-repository";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend, LayoutItem
} from "chart.js";

export const BarGraph: FC<{ dataSets: TeamProgressGraphStatistics}> = ({ dataSets }) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const colors = [
    "#ae302f",
    "#775653",
    "#0d9488",
    "#4338ca",
    "#c2410c",
  ];

  const sets = Object.entries(dataSets).map(([setName, values], index) => ({
    label: setName,
    data: values,
    backgroundColor: colors[index % colors.length],
    borderColor: colors[index % colors.length],
    borderWidth: 0
  }));
  console.log('sets', sets)

  const data = {
    labels: [],
    datasets: sets
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      }
    }
  };

  return <div className={'p-3'}>
    <Bar data={data} options={options} />
    <CustomLegend sets={sets} />
  </div>
}
const CustomLegend: FC<{sets: {label: string, borderColor: string}[]}> = props => {
  return <div className={'grid grid-cols-3 gap-2 px-1 pt-2'}>
    {props.sets.map((set, i) => {
      return <div key={i} className={'flex items-center'}>
        <div className={'h-5 w-5 rounded-md'} style={{background: `${set.borderColor}`}}></div>
        <div className={'text-xs font-medium ml-2'}>
          {set.label}
        </div>
      </div>
    })}
  </div>
}